import React from 'react';

const ManageVendors = () => {
  return (
    <div>
      <h1>Manage Vendors</h1>
      {/* Add vendor management interface */}
    </div>
  );
};

export default ManageVendors;